import React, { useState } from 'react';
import { usePostUncheckHook } from '../../hooks/post/usePostUncheck';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loading from '../../components/loading/loading.component';
import { Post } from '../../components';
import { RootState } from '../../configuration';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import _size from 'lodash/size';

const PostUncheck = (props) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const profileUser = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const {
    data: listPost,
    hasMore,
    loading,
  } = usePostUncheckHook({ pageNumber });
  return (
    <div className="lg:flex 2xl:gap-16 gap-12 w-full mx-auto">
      <Helmet>
        <title>Cab VN</title>
        <meta name="home" content="Cab VN" />
      </Helmet>
      <div className="w-full mx-auto px-6 py-10 2xl:p-10">
        <main className="w-full border borde-[#DEE0E6] rounded-2xl">
          <div className="px-4 py-3 text-[22px] leading-6 font-semibold text-[#18191E]">
            Danh sách bài viết chờ duyệt của bạn
          </div>
          {loading ? <Loading classname="mx-auto" /> : null}
          <div className="px-4 pb-4 2xl:px-8">
            {_size(listPost) ? (
              <InfiniteScroll
                dataLength={listPost.length}
                next={() => {
                  setPageNumber((prev) => prev + 1);
                }}
                hasMore={hasMore}
                loader={<Loading classname="mx-auto" />}
                endMessage={null}
                scrollableTarget="body"
                className="flex-1 h-fit grid grid-cols-2 gap-3 2xl:gap-6"
              >
                {listPost?.reverse()?.map((post, index) => {
                  return (
                    <Post
                      customClassName="h-fit"
                      isUnCheck
                      key={post.id}
                      post={post}
                      isPostUser={post.userId === profileUser?.userId}
                    />
                  );
                })}
              </InfiniteScroll>
            ) : null}
          </div>
        </main>
      </div>
    </div>
  );
};

export default PostUncheck;
